import { formatCurrency } from '@studio/atomic-ui'
import { SanitySmProduct } from '../services/sanity/types'
import { ProductType } from '../types/product'

export const productType: Record<SanitySmProduct['spaceType'], string> = {
  event_space: 'Event Space',
  day_pass: 'Day Pass',
  meeting_room: 'Meeting Room',
  office: 'Office',
  suite: 'Suite',
}

export const DEFAULT_SPACE_NAME = 'the-spiral'

export const priceLabel = (price: number, type: ProductType, priceRate = 1) => {
  switch (type) {
    case 'event_space':
      return `${formatCurrency(price * priceRate, true)}/${priceRate > 1 ? `${priceRate} hours` : 'hour'}`
    case 'day_pass':
      return `${formatCurrency(price, true)}/day`
    case 'meeting_room':
      return `${formatCurrency(price * priceRate, true)}/${priceRate > 1 ? `${priceRate} hours` : 'hour'}`
    case 'office':
      return `${formatCurrency(price, true)}/day`
    case 'suite':
      return `${formatCurrency(price, true)}/month`
  }
}
